module.exports = __webpack_public_path__ + "static/media/rota-mercados.ab887a4b.jpg";